import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Cloudinary } from 'services/cloudinary';
import { CimaCore } from 'services/index';
import { Util } from 'services/util';

@Component({
    selector: 'xm-multi-image-modal',
    templateUrl: 'multi.html',
    styleUrls: ['multi.scss'],
    standalone: false
})

export class MultiImageModal implements OnInit {
    public data: MultiImageModalData;
    private cimaCore: CimaCore;

    private dialogRef: MatDialogRef<MultiImageModal>;

    constructor(dialogRef: MatDialogRef<MultiImageModal>, @Inject(MAT_DIALOG_DATA) data: MultiImageModalData,  cimaCore: CimaCore) {
        Object.assign(this, { data, dialogRef, cimaCore});
    }

    public ngOnInit(): void {
        // clone the data just in case the data passed in is not copied
        this.data = Util.cloneProperties(this.data);

        if (this.data.primaryButton) {
            this.data.primaryButton = this.data.primaryButton.replace(/\[(.+?)\]/g, '[$$$$$1$$$$]');
        }

        if (this.cimaCore.isBusinessUser && this.data.cbmContent) {
            this.data.content = this.data.cbmContent;
        }

        this.data.content.forEach((content: MultiImageModalContent) => {
            content.imageOptions = {
                mobile: Cloudinary.generateMediaFromCms(content.image)
            };
        });
    }

    public close(action: string): void {
        const response: ModalResponse = {
            close: action === 'close',
            primary: action === 'primary',
            secondary: action === 'secondary'
        };

        this.dialogRef.close(response);
    }
}
